import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p", "br", "div", "span", "strong", "b", "em", "i", "u", "s",
  "sub", "sup", "blockquote", "ol", "ul", "li", "table", "thead",
  "tbody", "tr", "td", "th",
];

const ALLOWED_ATTR = [
  "class", "colspan", "rowspan", "width", "height", "align", "data-row", "data-cell",
];

export const sanitizeReportHtml = (html) =>
  DOMPurify.sanitize(html || "", {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ["style", "script", "iframe", "object", "embed", "form", "input", "button", "svg", "math"],
    FORBID_ATTR: ["style"],
  });

// Parse sanitized markup into nodes rather than assigning untrusted strings to
// an element's innerHTML. Existing generated content is preserved.
export const appendSanitizedReportHtml = (container, html) => {
  const parsedDocument = new DOMParser().parseFromString(
    sanitizeReportHtml(html),
    "text/html",
  );

  Array.from(parsedDocument.body.childNodes).forEach((node) => {
    container.appendChild(node.cloneNode(true));
  });
};
